import React from "react";
import { Typography } from "@mui/material";

function JoinCampaignLocationName({ children }) {
  return (
    <Typography component="h3" variant="body2" fontWeight="bold" py={0.7}>
      {children}
    </Typography>
  );
}

export default JoinCampaignLocationName;
